module.exports = __webpack_public_path__ + "assets/img/attachment.ac24d171.svg";